import React from 'react';
import { AuthProvider } from './AuthContext';
import { CartProvider } from './CartContext';
import { OrdersProvider } from './OrdersContext';

export * from './AuthContext';
export * from './CartContext';
export * from './OrdersContext';
export * from './Request';

// Context providers aggregator
export const AppProviders = ({ children }) => (
  <AuthProvider>
    <CartProvider>
      <OrdersProvider>{children}</OrdersProvider>
    </CartProvider>
  </AuthProvider>
);
